import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Problems from '../components/Problems';
import Solution from '../components/Solution';
import Services from '../components/Services';
import Benefits from '../components/Benefits';
import HowItWorks from '../components/HowItWorks';
import Privacy from '../components/Privacy';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <About />
      <Problems />
      <Solution />
      <Services />
      <Benefits />
      <HowItWorks />
      <Privacy />
      <CTA />
      <Footer />
    </div>
  );
};

export default HomePage;
